import { useState } from 'react'
import { SansText } from '@velasca/ui/sans-text'
import {
  PolicyTextContainer,
  StyledInlineInput,
  StyledTitleComposition,
  TextWrapper,
  Wrapper,
} from './NewsletterForm.styles'
import type { InsertEmailProps } from './NewsletterForm.types'

export const NewsletterForm = ({
  title,
  upperTitle,
  description,
  placeholder,
  privacyPolicyText,
  errorMessage,
  subscribe,
  status,
}: InsertEmailProps): JSX.Element => {
  const [email, setEmail] = useState('')

  return (
    <Wrapper>
      <StyledTitleComposition upperTitle={upperTitle} title={title} />

      <TextWrapper>
        <SansText
          as="div"
          size="md"
          color="dark"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </TextWrapper>

      <form
        onSubmit={(e) => {
          e.preventDefault()
          subscribe(email)
        }}
      >
        <StyledInlineInput
          required
          error={status === 'error'}
          loading={status === 'loading'}
          placeholder={placeholder}
          type="email"
          name="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value)
          }}
        />
      </form>

      {status === 'error' && (
        <SansText center size="sm" color="error">
          {errorMessage}
        </SansText>
      )}

      <PolicyTextContainer>
        <SansText
          center
          as="div"
          size="sm"
          color="dark"
          dangerouslySetInnerHTML={{ __html: privacyPolicyText }}
        />
      </PolicyTextContainer>
    </Wrapper>
  )
}
